import config from '@/config'

const axios = require('axios')

const mapService = {}

mapService.list = function() {
  return (
    axios
      .get(config.apiUrl + '/map/')
      // axios.get('https://vuetifyjs.com/es-MX/components/carousels/')
      .then(res => {
        return res
      })
      .catch(error => {
        console.error(error)
        return { status: 'error' }
      })
  )
}

export default mapService
